import Vue from "vue";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import ValidationErrors from "./components/ValidationErrors";
import { isLoggedIn } from "./js/utils/auth";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
//import LoadScript from "vue-plugin-load-script";
//import VModal from "vue-js-modal";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueSignaturePad from "vue-signature-pad";
Vue.use(VueSignaturePad);

import VField from "./components/VField";
Vue.component("v-field", VField);

//import JsonExcel from "vue-json-excel";
//Vue.component("downloadExcel", JsonExcel);
//import Vuelidate from "vuelidate";
//Vue.use(Vuelidate);

//Vue.use(VModal);
//Vue.use(LoadScript);

library.add(faUserSecret);

Vue.component("font-awesome-icon", FontAwesomeIcon);

if (location.hostname === "front.pgcmu.local") {
  Vue.prototype.$baseURL = "http://pgcmu.local:8000";
} else {
  Vue.prototype.$baseURL = "https://pgcmu.com";
}

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {
      next({
        name: "Home",
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
      next({
        name: "Dashboard",
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
}); //*/

Vue.component("v-errors", ValidationErrors);

//---------------- Axios Set up -------------//
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.axios.defaults.withCredentials = true;
if (location.hostname === "front.pgcmu.local") {
  window.axios.defaults.baseURL = "http://pgcmu.local:8000";
} else {
  window.axios.defaults.baseURL = "https://pgcmu.com";
  //window.axios.defaults.baseURL = "https://pgcnx.com";
}

window.axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (401 === error.response.status) {
      store.dispatch("logout");
    } else if (422 === error.response.status) {
      //console.log("422 err");
    }

    return Promise.reject(error);
  }
);
//--------------- End of Axios Set up ---------------//

//--------------- Vue Validation Set up -----------//
//This is a reusable component for showing validation state and error messages for each field
/* Vue.component("v-field", {
  template: `
  <div class="field" :class="{error:v.$error, valid:!v.$invalid, required:v.$params.required}">
  	<label>{{label}}</label>
    <slot></slot>
    <div class="note">
    	<slot name="note"></slot>
    </div>
    <div>{{message}}</div>
  </div>`,
  props: ["label", "v"],
  computed: {
    message() {
      if (this.v.$error) {
        for (let key in this.$options.messages) {
          if (this.v[key] === false) {
            return this.$options.messages[key](this.v);
          }
        }
      } else {
        return null;
      }
    },
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  messages: {
    //Add more messages here when you need, the key should be the same as the name of the validator
    required: (v) => "This field is required",
    email: (v) => "Must be a valid e-mail",
    alphaNum: (v) => "May only contain letters and numbers",
    minLength: (v) =>
      "Must be at least " + v.$params.minLength.min + " characters",
    goodPassword: (v) => "", //The password rules are always displayed, so no need to show a message
    sameAs: (v) => "Must be same as " + v.$params.sameAs.eq,
  },
}); */
//--------------- End of Vue Validation Set up -----------//

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
  async beforeCreate() {
    this.$store.dispatch("loadStoredState");
    this.$store.dispatch("loadUser");
  },
});
